import {
  FeaturedType,
  type Item,
} from '@wix/ambassador-restaurants-menus-v1-item/types';
import type { TFunction } from '@wix/yoshi-flow-editor';

export { FeaturedType };

export type SupportedFeaturedType = Exclude<
  FeaturedType,
  FeaturedType.UNKNOWN_FEATURED_TYPE
>;
const SUPPORTED_FEATURED_TYPES = new Set<FeaturedType>([
  FeaturedType.POPULAR,
  FeaturedType.BEST_SELLER,
  FeaturedType.NEW,
  FeaturedType.CHEF_SPECIAL,
  FeaturedType.RECOMMENDED,
  FeaturedType.SEASONAL,
  FeaturedType.FEATURED,
]);

const getFeaturedTypeLabels = (
  t: TFunction,
): Record<SupportedFeaturedType, string> => ({
  [FeaturedType.POPULAR]: t('menu_olo.item.featured-badge.popular'),
  [FeaturedType.BEST_SELLER]: t('menu_olo.item.featured-badge.best-seller'),
  [FeaturedType.NEW]: t('menu_olo.item.featured-badge.new'),
  [FeaturedType.CHEF_SPECIAL]: t('menu_olo.item.featured-badge.chef-special'),
  [FeaturedType.RECOMMENDED]: t('menu_olo.item.featured-badge.recommended'),
  [FeaturedType.SEASONAL]: t('menu_olo.item.featured-badge.seasonal'),
  [FeaturedType.FEATURED]: t('menu_olo.item.featured-badge.featured'),
});

export const isSupportedFeaturedType = (
  type?: FeaturedType | null,
): type is SupportedFeaturedType => {
  if (!type) {
    return false;
  }

  return SUPPORTED_FEATURED_TYPES.has(type);
};

export const getFeaturedTypeLabel = (
  type: SupportedFeaturedType,
  t: TFunction,
): string => getFeaturedTypeLabels(t)[type];

type FeaturedItemData = Pick<Item, 'featured' | 'featuredInfo'>;

/** Returns a badgeable type only when the item is explicitly featured. */
export const getItemFeaturedType = ({
  featured,
  featuredInfo,
}: FeaturedItemData): SupportedFeaturedType | undefined => {
  const featuredType = featuredInfo?.type;

  return featured && isSupportedFeaturedType(featuredType)
    ? featuredType
    : undefined;
};
